import { forwardRef } from "react";

import Icon from "@/components/Icon";
import InfoIconRaw from "./InfoIconRaw.svg.jsx";

const InfoIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={InfoIconRaw} title="Info" {...props} />;
});

export default InfoIcon;
